import React, { useState, useContext } from 'react';
import { motion } from 'framer-motion';
import { removeStrings } from '../../../api/connections/connections-api';
import { UserContext } from '../../../context/UserContext';
import { dismissModal } from '../../../service/modal-service';
import { SystemError } from '../../error/SystemError';
import { LoadingCover } from '../../commons/LoadingCover';
import BottomSheet from '../../commons/BottomSheet';
import { UserMinus, AlertTriangle } from 'lucide-react';

export const StringsRemove = (props) => {
    const getMyStrings = props.getMyStrings
    const editConnectionId = props.editConnectionId

    const [isOpen, setIsOpen] = useState(true)
    const [isLoading, setIsLoading] = useState(false)
    const [isSystemError, setIsSystemError] = useState(false)
    const [errorContent, setErrorContent] = useState({'header': "", 'body': ""})
    
    const { userId } = useContext(UserContext)

    const handleClose = () => {
        dismissModal()
    }

    const deleteStrings = async() => {
        if(!userId) return
        setIsLoading(true)
        try {
            await removeStrings(editConnectionId)
            setIsLoading(false)
            getMyStrings()
            dismissModal()
        } catch (error) {
            console.log(error)
            setErrorContent({ 'header': "Error removing connection", 'body': "Please try again. If problem persists, contact us at support@stringssg.com" })
            setIsSystemError(true)
            setIsLoading(false)
        }
    }

    return (
        <>
            <BottomSheet isOpen={isOpen} onClose={handleClose} maxWidth="md">
                <BottomSheet.Header>
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center">
                            <UserMinus className="w-5 h-5 text-red-600" />
                        </div>
                        <BottomSheet.Title>Remove Connection</BottomSheet.Title>
                    </div>
                </BottomSheet.Header>

                <BottomSheet.Content>
                    <div className="flex items-start gap-3 p-4 bg-amber-50 rounded-xl border border-amber-100">
                        <AlertTriangle className="w-5 h-5 text-amber-500 shrink-0 mt-0.5" />
                        <div>
                            <p className="text-sm text-gray-700">
                                Are you sure you want to remove this connection?
                            </p>
                            <p className="text-xs text-gray-500 mt-1">
                                You will no longer be able to see each other&apos;s private content.
                            </p>
                        </div>
                    </div>
                </BottomSheet.Content>

                <BottomSheet.Footer>
                    <div className="flex gap-3">
                        <BottomSheet.CloseButton>Cancel</BottomSheet.CloseButton>
                        <motion.button 
                            whileTap={{ scale: 0.98 }}
                            type="button" 
                            className="flex-1 px-4 py-3 rounded-xl font-semibold text-white bg-linear-to-r from-red-600 to-red-500 shadow-lg shadow-red-200 disabled:opacity-50 flex items-center justify-center gap-2" 
                            disabled={isLoading}
                            onClick={deleteStrings}
                        >
                            <UserMinus className="w-4 h-4" />
                            {isLoading ? 'Removing...' : 'Remove'}
                        </motion.button>
                    </div>
                </BottomSheet.Footer>
            </BottomSheet>

            {isLoading && <LoadingCover />}
            {isSystemError && <SystemError errorContent={errorContent} setIsSystemError={setIsSystemError} />}
        </>
    )
}
